import classnames from 'classnames/bind';
import React from 'react';
import styles from './IconButton.scss';
import { FluentSvgIcon } from './FluentSvgIcon';
import type { IconButtonProps } from '../schema/FluentSvgIcon.types';

const cx = classnames.bind(styles);

export const IconButton = React.forwardRef(
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    (props: IconButtonProps, ref?: React.RefObject<any>): JSX.Element => {
        const {
            icon,
            iconStyles,
            iconContainerStyles,
            ariaLabel,
            disabled,
            ariaHasPopup,
            onClick,
            ariaLive,
            tabIndex,
            className,
            primary,
            ...remainingProps
        } = props;

        return (
            <button
                ref={ref}
                className={cx(
                    cx(
                        styles.button,
                        primary && styles.primaryButton,
                        disabled && styles.disabledButton
                    ),
                    className
                )}
                role={'button'}
                tabIndex={tabIndex ? tabIndex : 0}
                aria-label={ariaLabel}
                aria-live={ariaLive}
                aria-haspopup={!!ariaHasPopup}
                aria-disabled={disabled}
                onClick={onClick}
                {...remainingProps}>
                <FluentSvgIcon
                    icon={icon}
                    iconContainerStyles={iconContainerStyles}
                    iconStyles={iconStyles}
                />
            </button>
        );
    }
);
